import { render, staticRenderFns } from "./myVisit.vue?vue&type=template&id=1d72629c&scoped=true"
import script from "./myVisit.vue?vue&type=script&lang=js"
export * from "./myVisit.vue?vue&type=script&lang=js"
import style0 from "./myVisit.vue?vue&type=style&index=0&id=1d72629c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d72629c",
  null
  
)

export default component.exports